import { ENVIRONMENT_IS_DEVELOPMENT } from "@/src/util/development";
import Head from "next/head";

interface Props { subtitle?: string };

export default function Title(
    { subtitle }: Props,
) {
    const devText = ENVIRONMENT_IS_DEVELOPMENT ? '[DEV] ' : '';

    const subtext = subtitle
        ? ` - ${subtitle}`
        : '';

    return (
        <Head>
            <title>{devText}{`S•P•Q•R${subtext}`}</title>
        </Head>
    )
}
